<template>
    <v-app>
        <div class="login-wrapper">
            <div class="login-form">
                <v-form v-if="step === 'login'" @submit.prevent="login">
                    <img src="https://fuab.aplicacionesmdy.com/public/assets/media/logos/logo-2.svg" alt="MDY"
                        width="120" class="mb-4">

                    <h3 class="login-title">INICIAR SESIÓN</h3>
                    <p class="login-subtitle">Ingresa tu nombre de usuario y contraseña para ingresar</p>

                    <v-text-field v-model="username" label="Nombre de usuario" required hide-details="auto"
                        class="mb-3"></v-text-field>
                    <v-text-field v-model="password" label="Contraseña" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show ? 'text' : 'password'" @click:append="show = !show" required hide-details="auto" class="mb-6"></v-text-field>

                    <v-btn color="#315b2c" type="submit" block :loading="loading" class="btn-login text-none">
                        ACCEDER
                    </v-btn>

                    <div class="text-center mt-6">
                        <a href="#" @click.prevent="dialog = true" class="forgot-link">¿Recuperar contraseña?</a>
                    </div>
                </v-form>

                <v-form v-if="step === 'reset'" @submit.prevent="actualizarPassword">
                    <img src="https://fuab.aplicacionesmdy.com/public/assets/media/logos/logo-2.svg" alt="MDY"
                        width="120" class="mb-4">
                    <h3 class="login-title">ACTUALIZAR CLAVE</h3>
                    <p class="login-subtitle">Por seguridad, debes crear una nueva contraseña para continuar</p>

                    <v-text-field v-model="newPassword" label="Nueva Contraseña" outlined dense
                        class="mb-0" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                    <v-progress-linear :value="passwordStrength.score" :color="passwordStrength.color" height="5"
                        class="mt-n2 mb-2"></v-progress-linear>
                    <p :class="`${passwordStrength.color}--text`" class="caption text-right mb-4">
                        Seguridad: {{ passwordStrength.label }}
                    </p>
                    <v-text-field v-model="confirmPassword" label="Confirmar Contraseña"  outlined dense
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :type="show2 ? 'text' : 'password'"
                        @click:append="show2 = !show2"></v-text-field>

                    <v-btn color="#315b2c" type="submit" block :loading="loading" class="mb-3" dark>
                        ACTUALIZAR
                    </v-btn>
                </v-form>

                <div class="custom-footer">
                    © MDY 2026. Todos los derechos reservados.
                </div>
            </div>

            <div class="login-visual">
                <h1 class="banner-title text-orange">WI PLANNING</h1>
                <img src="../../public/images/chica-slider-2.webp" alt="Chica MDY" class="chica-img">
            </div>
        </div>
        <v-dialog v-model="dialog" max-width="400" persistent>
            <v-card>
                <v-card-title class="headline primary white--text  justify-center">Solicitud de Cambio de
                    Clave</v-card-title>
                <v-card-text class="pt-4">
                    <p class="body-2 grey--text">
                        Por favor, ingresa tu nombre de usuario para enviarte a tu correo la contraseña por defecto.
                    </p>
                    <v-text-field v-model="userRecuperar" label="Nombre de Usuario" outlined dense
                        prepend-inner-icon="mdi-account" hide-details="auto"></v-text-field>
                </v-card-text>
                <v-card-actions class="pb-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialog = false" :disabled="loadingRecuperar">Cancelar</v-btn>
                    <v-btn color="primary" text @click="recuperarClave" :loading="loadingRecuperar">Enviar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            username: '',
            password: '',
            dialog: false,
            userRecuperar: '',
            loadingRecuperar: false,
            step: 'login',
            newPassword: '',
            confirmPassword: '',
            userIdForReset: null,
            show: false,
            show1: false,
            show2: false
        }
    },
    computed: {
        passwordStrength() {
            if (!this.newPassword) return { score: 0, label: '', color: 'grey' };

            let score = 0;
            // 1. Longitud mínima
            if (this.newPassword.length >= 6) score++;
            // 2. Tiene números
            if (/[0-9]/.test(this.newPassword)) score++;
            // 3. Tiene Mayúsculas
            if (/[A-Z]/.test(this.newPassword)) score++;
            // 4. Tiene caracteres especiales
            if (/[!@#$%^&*(),.?":{}|<>]/.test(this.newPassword)) score++;

            switch (score) {
                case 0:
                case 1: return { score: 25, label: 'Muy Débil', color: 'red' };
                case 2: return { score: 50, label: 'Débil', color: 'orange' };
                case 3: return { score: 75, label: 'Segura', color: 'blue' };
                case 4: return { score: 100, label: 'Muy Fuerte', color: 'green' };
                default: return { score: 0, label: '', color: 'grey' };
            }
        }
    },
    methods: {
        async login() {
            this.loading = true;
            try {
                const response = await this.$axios.post('login', {
                    username: this.username,
                    password: this.password
                });

                if (response.data.status === 'change_password') {
                    this.step = 'reset';
                    this.userIdForReset = response.data.data.usuario_id;
                    //console.log('userIdForReset', this.userIdForReset);
                    this.$toast.info("Por favor actualice su contraseña");
                } else if (response.data.status === 'success') {
                    const userData = response.data.data.usuario;
                    const menuData = response.data.data.menus || [];

                    // Commits y Dispatches
                    this.$store.dispatch('updateMenuItems', menuData);
                    this.$store.commit('setToken', userData[2]);
                    //sessionStorage.setItem("token", userData[2]);
                    this.$store.commit('setUsername', `${userData[3]} ${userData[4]} ${userData[5]}`);
                    this.$store.commit('setRole', userData[1]);
                    this.$store.commit('setId', userData[0]);
                    this.$store.commit('setPais', userData[11]);
                    this.$store.commit('setAuth', true);

                    await this.fetchInitialData();
                    this.$router.push('/main');
                    this.$toast.success('Bienvenido usuario', { timeout: 1400 });
                } else {
                    this.$toast.error(response.data.message);
                }
            } catch (error) {
                this.$toast.error("Error en la solicitud");
            } finally {
                this.loading = false;
            }
        },
        async fetchInitialData() {
            const actions = ['listCenter', 'listCampañas', 'listSegmentos', 'listUsuarios', 'listClientes', 'listDatosTaf'];
            await Promise.all(actions.map(action => this.$store.dispatch(action)));
        },
        async recuperarClave() {
            if (!this.userRecuperar.trim()) {
                this.$toast.warning("Por favor, ingresa tu nombre de usuario");
                return;
            }

            this.loadingRecuperar = true;
            try {
                // 2. Preparar la cadena según el formato que espera el procedimiento (op†usuario)
                const cadenaParam = `1†${this.userRecuperar.trim()}`;

                // 3. Llamada al endpoint de Laravel (ajústalo según tu api.php)
                const response = await this.$axios.post('reset-password', {
                    cadena: cadenaParam
                });

                if (response.data.status === 'success') {
                    // El servidor nos devuelve éxito si el procedimiento SQL devolvió datos
                    this.$toast.success('Solicitud procesada. Revisa tu correo electrónico.');

                    this.dialog = false;
                    this.userRecuperar = '';
                } else {
                    // El procedimiento SQL no encontró al usuario o está inactivo
                    this.$toast.error(response.data.message || 'Usuario no encontrado o inactivo');
                }
            } catch (error) {
                console.error(error);
                const msg = error.response?.data?.message || "Error al procesar la solicitud";
                this.$toast.error(msg);
            } finally {
                this.loadingRecuperar = false;
            }
        },
        async actualizarPassword() {
            if (!this.newPassword || !this.confirmPassword) {
                this.$toast.error("Por favor, complete ambos campos");
                return;
            }

            if (this.newPassword !== this.confirmPassword) {
                this.$toast.error("Las contraseñas no coinciden");
                return;
            }

            if (this.newPassword.length < 6) {
                this.$toast.error("La contraseña debe tener al menos 6 caracteres");
                return;
            }

            this.loading = true;
            try {
                const response = await this.$axios.post('update-password-first-time', {
                    id: this.userIdForReset,
                    password: this.newPassword
                });

                if (response.data.status === 'success') {
                    this.$toast.success("Contraseña actualizada con éxito");

                    this.step = 'login';
                    this.password = '';
                    this.newPassword = '';
                    this.confirmPassword = '';
                } else {
                    this.$toast.error(response.data.message || "Error al actualizar");
                }
            } catch (error) {
                console.error("Error en actualización:", error);
                this.$toast.error("Error de comunicación con el servidor");
            } finally {
                this.loading = false;
            }
        },

    }
}
</script>

<style scoped>
.login-wrapper {
    background-image: url('../../public/images/slider-home-1.webp');
    background-size: cover;
    background-position: center;
    display: flex;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
}

.login-form {
    flex: 0 0 450px;
    background: #ffffff;
    padding: 3rem;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.login-visual {
    flex: 1;
    position: relative;
    padding: 4rem;
    display: flex;
    flex-direction: column;
}

.chica-img {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 83%;
    width: auto;
    object-fit: contain;
    z-index: 1;
    transition: opacity 0.3s ease;
}

.login-title {
    font-size: 1.5rem;
    font-weight: 300;
    color: #48465b;
    margin-bottom: 0.5rem;
    font-family: 'Poppins', sans-serif;
}

.login-subtitle {
    font-size: 12px;
    color: #a7abc3;
    margin-bottom: 2rem;
}

.btn-login {
    background-color: #315c2c !important;
    color: white !important;
    border-radius: 60px;
    height: 48px;
    font-weight: 500;
}

.banner-title {
    font-size: 2.5rem;
    font-weight: 300;
    z-index: 2;
}

.text-orange {
    color: #ff9f43 !important;
}

.custom-footer {
    position: absolute;
    bottom: 20px;
    left: 3rem;
    font-size: 11px;
    color: #a7abc3;
}

.forgot-link {
    color: #5d78ff;
    text-decoration: none;
    font-size: 0.85rem;
}

/* Responsividad básica */
@media (max-width: 960px) {
    .login-visual {
        display: none;
    }

    .login-form {
        flex: 1;
        max-width: 100%;
    }
}

@media (max-width: 1264px) {
    .chica-img {
        height: 40%;
        /* Se encoge un poco en pantallas medianas */
    }

    .banner-title {
        font-size: 1.8rem;
    }
}
</style>